import CityPageTemplate from "../city-template/CityPageTemplate";
import { northglennConfig } from "./data";

export default function NorthglennPage() {
  return <CityPageTemplate config={northglennConfig} />;
}